import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import CustomCard from "../../components/d-reusable/CustomCard";
import ProjectStatusCard from "../../components/d-dashboard/ProjectStatusCard";
import { dentalIcons } from "../../utils-icons/dentalIcons";
import TitleWithIconLink from "../../components/d-reusable/TitleWithIconLink";
import ProjectGraphAndTable from "../../components/d-dashboard/ProjectGraphAndTable";
import { dentalBasePath, errorRequestHandel } from "../../../helper";
import RecentProjects from "../../components/d-dashboard/RecentProjects";
import { getDashboardData } from "../../../components/https/projects-apis";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { _setProjectTab } from "../../../redux/actions/generalAction";
import DashboardSkeleton from "../../components/skeletons/DashboardSkeleton";
import CustomPrimaryButton from "../../components/d-reusable/CustomPrimaryButton";
import ProjectsShortCut from "../../components/d-dashboard/porjects-short-cut/ProjectsShortCut";

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dashboardData();
  }, []);

  const dashboardData = async () => {
    try {
      setLoading(true);
      const response = await getDashboardData();
      if (response.status === 200) {
        setData(response.data.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error: error });
    }
  };

  const navigation = (type) => {
    // all,open,completed,archive
    dispatch(_setProjectTab(type));
    navigate(`${dentalBasePath}/projects`);
  };

  const onCreateNewProject = () => {
    navigate(`${dentalBasePath}/new-project`);
  };
  // if (loading) {
  //   return <DashboardSkeleton />;
  // }

  return (
    <div>
      <ProjectsShortCut />
      <TitleWithIconLink
        title={"Overview"}
        linkText={"New Project"}
        icon={dentalIcons.rounderPlusIcon}
        linkUrl={onCreateNewProject}
        isDirty={false}
      />
      <Row gutter={[20, 20]}>
        <Col md={8} sm={24} xs={24}>
          <CustomCard>
            <ProjectStatusCard
              title={"All Projects"}
              bgColor={"#E3EBFF"}
              icon={dentalIcons?.totalProjectsIcon}
              count={data?.total_projects}
              onClick={() => navigation("all")}
            />
          </CustomCard>
        </Col>
        <Col md={8} sm={24} xs={24}>
          <CustomCard>
            <ProjectStatusCard
              title={"Active Projects"}
              bgColor={"#DEF5DB"}
              icon={dentalIcons?.activeProjectsIcon}
              count={data?.active_projects}
              onClick={() => navigation("open")}
            />
          </CustomCard>
        </Col>
        <Col md={8} sm={24} xs={24}>
          <CustomCard>
            <ProjectStatusCard
              title={"Completed Projects"}
              bgColor={"#D2F3FA"}
              icon={dentalIcons?.completedProjectIcon}
              count={data?.completed_projects}
              onClick={() => navigation("completed")}
            />
          </CustomCard>
        </Col>
      </Row>
      <br />
      <br />
      <ProjectGraphAndTable data={data} />
      <br />
      <br />
      <RecentProjects data={data?.recent_projects || []} />
    </div>
  );
};

export default Dashboard;
